/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import scrollToElement from "../utils/scrollToElement";

class FilterGalleryForm {
    constructor() {
        if (document.querySelector(".gallery-section")) {
            this.init();
        }
        this.selectedFilters = [];
        this._handlingFormEvent = false;
        this._eventsBound = false;
    }

    updateSelectedFilters($form, isVerticalLayout = false, enableFavorites = false) {
        const selected = $form
            .serializeArray()
            .filter(item => item.name !== "show-favorites-only" && item.value && `${item.value}`.trim() !== "")
            .map(item => ({
                name: item.name,
                value: `${item.value}`.trim()
            }));

        // Search keyword chiclet
        const keyword = isVerticalLayout ? $("#vertical-keyword-search").val() : $("#keyword-search").val();
        if (keyword && keyword.trim().length > 2) {
            selected.push({ name: "keyword", value: keyword.trim() });
        }

        this.selectedFilters = selected;
        return this.selectedFilters;
    }
    handleChapters(targetVideoPlayer) {
        function updateChapters(player) {
            var currentTime = player.currentTime();
            (this.el, this.startTime <= currentTime && currentTime < this.endTime) ? this.el.addClass("active") : this.el.removeClass("active");
        }

        function handleChapterChange(player) {
            player.currentTime($(this).data("time"));
        }

        let chapters = $($(targetVideoPlayer.el()).data("chapters-container"));

        //check for chapters container next to video
        if (!chapters.length) return false;

        //empty chapters container
        chapters.html("");

        //chapters demo
        let chapterTT = [].filter.call(targetVideoPlayer.remoteTextTracks(), function(tt) {
            return tt.kind === "chapters";
        });

        //check if metadata type is chapters
        if (!chapterTT) {
            $(".chapters__tab").hide();
            $(".transcript__tab a").tab("show");
            $(targetVideoPlayer.el()).removeClass("hasChapters");
            return false;
        } else {
            $(targetVideoPlayer.el()).addClass("hasChapters");
            $(".chapters__tab").show();
            $("#webinar-chapters").show();
        }

        //loop through chapter metadata
        let cuesAra = chapterTT[0].cues;
        if (cuesAra && cuesAra.length > 0) {
            for (var i = 0; i < cuesAra.length; i++) {
                var $el = $('<li><span class="start-time">' + videojs.formatTime(cuesAra[i].startTime, "M:SS") + "</span> " + cuesAra[i].text + "</li>");

                //create chapter elements
                $el.data("time", cuesAra[i].startTime)
                    .on("click", $.proxy(handleChapterChange, $el, targetVideoPlayer))
                    .appendTo(chapters);

                cuesAra[i].el = $el;

                targetVideoPlayer.remoteTextTracks()[0].addEventListener("cuechange", $.proxy(updateChapters, cuesAra[i], targetVideoPlayer));
            }
        }
    }

    loadFavorites() {
        try {
            const favorites = localStorage.getItem("dupixent_gallery_favorites");
            if (!favorites) {
                return [];
            }

            const parsedFavorites = JSON.parse(favorites);
            return Array.isArray(parsedFavorites) ? parsedFavorites : [];
        } catch (error) {
            return [];
        }
    }

    saveFavorites(favorites) {
        localStorage.setItem("dupixent_gallery_favorites", JSON.stringify(favorites));
        // Update count display
        $(".favorites-count").text(favorites.length);
    }

    toggleFavorite(itemId) {
        if (!itemId) {
            return [];
        }

        let favorites = this.loadFavorites();
        const index = favorites.indexOf(itemId);

        if (index === -1) {
            // Add to favorites
            favorites.push(itemId);
            $(`.gallery-item[data-item-id="${itemId}"] .favorite-toggle i`)
                .removeClass("fa-regular")
                .addClass("fa-solid");
            $(`.gallery-item[data-item-id="${itemId}"] .favorite-toggle`).attr("title", "Remove from favorites");
        } else {
            // Remove from favorites
            favorites.splice(index, 1);
            $(`.gallery-item[data-item-id="${itemId}"] .favorite-toggle i`)
                .removeClass("fa-solid")
                .addClass("fa-regular");
            $(`.gallery-item[data-item-id="${itemId}"] .favorite-toggle`).attr("title", "Add to favorites");
        }

        this.saveFavorites(favorites);
        return favorites;
    }

    updateFavoriteIcons() {
        const favorites = this.loadFavorites();
        $(".favorite-toggle i")
            .removeClass("fa-solid")
            .addClass("fa-regular");
        $(".favorite-toggle").attr("title", "Add to favorites");

        favorites.forEach(itemId => {
            $(`.gallery-item[data-item-id="${itemId}"] .favorite-toggle i`)
                .removeClass("fa-regular")
                .addClass("fa-solid");
            $(`.gallery-item[data-item-id="${itemId}"] .favorite-toggle`).attr("title", "Remove from favorites");
        });
    }

    // Check if any filters are currently applied
    checkFiltersApplied($form, isVerticalLayout, enableFavorites, excludeFavorites = false) {
        // Check form fields
        const formData = $form.serializeArray();
        const hasFormFilters = formData.some(item => {
            // Exclude favorites checkbox since we handle that separately
            return item.name !== "show-favorites-only" && item.value;
        });

        // Check keyword search
        const keywordField = isVerticalLayout ? $("#vertical-keyword-search") : $("#keyword-search");
        const hasKeywordSearch = keywordField.length && keywordField.val().length > 2;

        // Check favorites filter (only if not excluding favorites)
        let hasFavoritesFilter = false;
        if (enableFavorites && !excludeFavorites) {
            hasFavoritesFilter = isVerticalLayout ? $(".favorites-btn").hasClass("active") : $("#show-favorites-only").is(":checked");
        }

        return hasFormFilters || hasKeywordSearch || hasFavoritesFilter;
    }

    // Update filter button active state based on applied filters
    updateFilterButtonState($form, $filterBtn, isVerticalLayout, enableFavorites) {
        // Check if favorites are currently active
        let favoritesActive = false;
        if (enableFavorites && isVerticalLayout) {
            favoritesActive = $(".favorites-btn").hasClass("active");
        }

        // If favorites are active, remove has-filters class regardless of other filters
        if (favoritesActive) {
            $filterBtn.removeClass("has-filters");
        } else {
            // Only check other filters if favorites are not active
            const hasFilters = this.checkFiltersApplied($form, isVerticalLayout, enableFavorites, true);

            if (hasFilters) {
                $filterBtn.addClass("has-filters");
            } else {
                $filterBtn.removeClass("has-filters");
            }
        }
    }
    renderSelectedFilterChiclets(containerSelector, $form, isVerticalLayout = false, enableFavorites = false) {
        const $container = $(containerSelector);
        if (!$container.length) return;

        const selected = this.updateSelectedFilters($form, isVerticalLayout, enableFavorites);
        const $list = $('<ul class="filter-chiclet-list" aria-label="Selected filters"></ul>');

        selected.forEach(item => {
            const label = item.name == "keyword" ? `Keyword: ${item.value}` : item.value;

            const $btn = $("<button/>", {
                class: "chiclet btn btn--basic",
                type: "button",
                "aria-label": `Remove filter: ${label}`
            })
                .append($("<span/>", { text: label }))
                .append($("<i/>", { class: "fa-solid fa-times" }));
            $("<li/>")
                .append($btn)
                .appendTo($list);

            $btn.on("click", () => {
                $form.find(`input[name="${item.name}"][value="${item.value}"]`).prop("checked", false);
                $form.trigger(isVerticalLayout ? "apply-filters" : "input");
            });
        });
        $container.empty().append($list);
    }

    init() {
        const $this = this;
        const $gallerySection = $(".gallery-section");
        const isVerticalLayout = $gallerySection.hasClass("vertical-layout");
        const enableFavorites = $gallerySection.data("enable-favorites") === true;
        const $form = isVerticalLayout ? $("#filter-popover-form") : $("#filter-form");
        const $gallery = $(".carousel-inner");
        const $carousel = $("#video-gallery");
        const $prev = $(".controls-wrap .prev");
        const $next = $(".controls-wrap .next");
        const $controls = $(".controls-wrap");
        const $resetItems = $(".gallery-item");
        const $filterPopover = $("#filter-popover");
        const $filterBtn = isVerticalLayout ? $("#show-filters-btn") : null;
        let length = $("#video-gallery .item").length;
        const itemsDesktop = $form.data("desktop-items") || 12;
        const itemsMobile = $form.data("mobile-items") || 4;
        const selectedFilterContainer = $(".filter-chiclet-container");

        let BRIGHTCOVEACCOUNT = 5186843675001;
        let BRIGHTCOVEPLAYERID = "OR7JLFY9F";

        // Store reference to element that triggered the modal for focus management
        let modalTriggerElement = null;

        // Store the last applied filter state for vertical layout
        let lastAppliedFilterState = null;

        // Function to save current form state
        const saveFormState = () => {
            if (!isVerticalLayout) return null;

            const formData = $form.serializeArray();
            const keywordValue = $("#vertical-keyword-search").length ? $("#vertical-keyword-search").val() : "";
            let favoritesActive = $(".favorites-btn").hasClass("active");

            // If favorites filter is active but no items are actually favorited, clear it
            if (favoritesActive) {
                const currentFavorites = $this.loadFavorites();
                if (currentFavorites.length === 0) {
                    favoritesActive = false;
                    // Also clear the UI state immediately
                    $(".favorites-btn")
                        .removeClass("active")
                        .find("i")
                        .removeClass("fa-solid")
                        .addClass("fa-regular");
                }
            }

            const state = {
                formData: formData,
                keyword: keywordValue,
                favorites: favoritesActive
            };

            return state;
        };

        // Function to restore form state
        const restoreFormState = state => {
            if (!isVerticalLayout || !state) return;

            // Clear all form inputs first
            $form[0].reset();
            $("#vertical-keyword-search").val("");

            // Restore form data
            state.formData.forEach(item => {
                $form.find(`input[name="${item.name}"][value="${item.value}"]`).prop("checked", true);
            });

            // Restore keyword search
            if (state.keyword) {
                $("#vertical-keyword-search").val(state.keyword);
            }

            // Restore favorites state, but only if there are actually favorite items
            if (state.favorites) {
                const currentFavorites = $this.loadFavorites();
                if (currentFavorites.length > 0) {
                    $(".favorites-btn")
                        .addClass("active")
                        .find("i")
                        .removeClass("fa-regular")
                        .addClass("fa-solid");
                } else {
                    // Clear favorites filter if no items are favorited
                    $(".favorites-btn")
                        .removeClass("active")
                        .find("i")
                        .removeClass("fa-solid")
                        .addClass("fa-regular");
                }
            } else {
                $(".favorites-btn")
                    .removeClass("active")
                    .find("i")
                    .removeClass("fa-solid")
                    .addClass("fa-regular");
            }
        };

        //add class to body
        document.body.classList.add("filterGalleryFormPage");

        // Initialize favorites if enabled
        if (enableFavorites) {
            const favorites = this.loadFavorites();
            $(".favorites-count").text(favorites.length);
            this.updateFavoriteIcons();

            // Handle favorite toggle clicks
            $(document).on("click", ".favorite-toggle", function(e) {
                e.stopPropagation();
                const itemId = $(this)
                    .closest(".gallery-item")
                    .data("item-id");
                const favorites = $this.toggleFavorite(itemId);

                // If favorites filter is active but no items are favorited anymore, clear it
                if (enableFavorites && $(".favorites-btn").hasClass("active") && favorites.length === 0) {
                    $(".favorites-btn")
                        .removeClass("active")
                        .find("i")
                        .removeClass("fa-solid")
                        .addClass("fa-regular");

                    // In vertical layout, if the popup is not open, trigger filtering immediately
                    // Otherwise wait for Apply button
                    if (!isVerticalLayout || !$filterPopover.hasClass("open")) {
                        $form.trigger(isVerticalLayout ? "apply-filters" : "input");
                    }
                } else {
                    // Normal favorite toggle behavior
                    // If in favorites-only mode, re-filter content
                    // In vertical layout, only filter immediately if popup is not open
                    if ($("#show-favorites-only").is(":checked") || $(".favorites-btn").hasClass("active")) {
                        if (!isVerticalLayout || !$filterPopover.hasClass("open")) {
                            $form.trigger(isVerticalLayout ? "apply-filters" : "input");
                        }
                    }
                }
            });

            // Handle show favorites only checkbox in classic layout
            $("#show-favorites-only").on("change", function() {
                $form.trigger("input");
            });

            // Handle favorites button in vertical layout
            $(".favorites-btn").on("click", function() {
                $(this).toggleClass("active");
                // Toggle the heart icon between regular and solid
                if ($(this).hasClass("active")) {
                    $(this)
                        .find("i")
                        .removeClass("fa-regular")
                        .addClass("fa-solid");
                } else {
                    $(this)
                        .find("i")
                        .removeClass("fa-solid")
                        .addClass("fa-regular");
                }
                // In vertical layout, only trigger immediate filtering if popup is not open
                // Otherwise, wait for Apply button to be clicked
                if (!isVerticalLayout || !$filterPopover.hasClass("open")) {
                    $form.trigger(isVerticalLayout ? "apply-filters" : "input");
                }

                // Update filter button state immediately if in vertical layout
                if (isVerticalLayout && $filterPopover && $filterBtn) {
                    $this.updateFilterButtonState($form, $filterBtn, isVerticalLayout, enableFavorites);
                }
            });
        }

        // Handle filter popover in vertical layout
        if (isVerticalLayout) {
            // Find parent score-container and apply styles to fix z-index issues
            const fixScoreContainerZIndex = show => {
                const $parentScoreContainer = $gallerySection.closest(".score-container");
                if ($parentScoreContainer.length) {
                    if (show) {
                        // Store original styles to restore later
                        $parentScoreContainer.data("original-position", $parentScoreContainer.css("position"));
                        $parentScoreContainer.data("original-zindex", $parentScoreContainer.css("z-index"));

                        // Apply new styles to ensure proper stacking
                        $parentScoreContainer.css({
                            position: "relative",
                            "z-index": "1"
                        });
                    } else {
                        // Restore original styles
                        if ($parentScoreContainer.data("original-position")) {
                            $parentScoreContainer.css("position", $parentScoreContainer.data("original-position"));
                        }

                        if ($parentScoreContainer.data("original-zindex")) {
                            $parentScoreContainer.css("z-index", $parentScoreContainer.data("original-zindex"));
                        } else {
                            $parentScoreContainer.css("z-index", "");
                        }
                    }
                }
            };

            // Position popover function
            const positionPopover = () => {
                const buttonOffset = $filterBtn.offset();
                const buttonWidth = $filterBtn.outerWidth();
                const buttonHeight = $filterBtn.outerHeight() || 0;

                // Position popover
                $filterPopover.css({
                    top: buttonHeight
                });
            };

            // Toggle filter popover
            $filterBtn.on("click", function(e) {
                e.stopPropagation();

                // Deselect Favorites toggle if currently selected
                if ($(".favorites-btn").hasClass("active")) {
                    $(".favorites-btn")
                        .removeClass("active")
                        .find("i")
                        .removeClass("fa-solid")
                        .addClass("fa-regular");
                    // Update filter button state since favorites was deselected
                    $this.updateFilterButtonState($form, $filterBtn, isVerticalLayout, enableFavorites);
                }

                if (!$filterPopover.hasClass("open")) {
                    positionPopover();
                    fixScoreContainerZIndex(true);
                    $filterPopover.addClass("open").attr("aria-hidden", "false");
                    $filterBtn.addClass("active").attr("aria-expanded", "true");

                    const currentResults = $gallerySection.data("total-filtered-items") || 0;
                    if (currentResults === 0) {
                        const popoverHeight = $filterPopover.outerHeight();
                        $gallerySection.css("min-height", popoverHeight + 100 + "px"); // Add some padding
                    }

                    // Focus management for accessibility
                    $filterPopover.attr("aria-modal", "true");
                    $(".close-filters").focus();
                } else {
                    $filterPopover.removeClass("open").attr("aria-hidden", "true");
                    fixScoreContainerZIndex(false);
                    $filterBtn.removeClass("active").attr("aria-expanded", "false");
                    $filterPopover.attr("aria-modal", "false");
                    $gallerySection.css("min-height", "auto");
                    $filterBtn.focus();
                }
            });

            // Update position on window resize
            $(window).on("resize", function() {
                if ($filterPopover.hasClass("open")) {
                    positionPopover();
                }
            });

            // Close filters with close button
            $(".close-filters").on("click", function(e) {
                e.stopPropagation();
                // Restore last applied state when closing without applying
                restoreFormState(lastAppliedFilterState);
                $filterPopover.removeClass("open").attr("aria-hidden", "true");
                fixScoreContainerZIndex(false);
                $filterBtn.removeClass("active").attr("aria-expanded", "false");
                $filterPopover.attr("aria-modal", "false");
                $filterBtn.focus();
            });

            // Handle Escape key for accessibility
            $filterPopover.on("keydown", function(e) {
                if (e.key === "Escape") {
                    // Restore last applied state when closing without applying
                    restoreFormState(lastAppliedFilterState);
                    $filterPopover.removeClass("open").attr("aria-hidden", "true");
                    fixScoreContainerZIndex(false);
                    $filterBtn.removeClass("active").attr("aria-expanded", "false");
                    $filterPopover.attr("aria-modal", "false");
                    $filterBtn.focus();
                }
            });

            // Trap focus within popup for accessibility
            $filterPopover.on("keydown", function(e) {
                if (e.key === "Tab") {
                    const focusableElements = $filterPopover.find('button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
                    const firstElement = focusableElements.first();
                    const lastElement = focusableElements.last();

                    if (e.shiftKey && $(document.activeElement).is(firstElement)) {
                        e.preventDefault();
                        lastElement.focus();
                    } else if (!e.shiftKey && $(document.activeElement).is(lastElement)) {
                        e.preventDefault();
                        firstElement.focus();
                    }
                }
            });

            // Handle Enter key on checkboxes for accessibility
            $filterPopover.on("keydown", "input[type='checkbox']", function(e) {
                if (e.key === "Enter") {
                    e.preventDefault();
                    $(this).prop("checked", !$(this).prop("checked"));
                }
            });

            // Close on click outside
            $(document).on("click", function(e) {
                if ($filterPopover.hasClass("open") && !$(e.target).closest($filterPopover).length && !$(e.target).closest($filterBtn).length) {
                    // Restore last applied state when closing without applying
                    restoreFormState(lastAppliedFilterState);
                    $filterPopover.removeClass("open").attr("aria-hidden", "true");
                    fixScoreContainerZIndex(false);
                    $filterBtn.removeClass("active").attr("aria-expanded", "false");
                    $filterPopover.attr("aria-modal", "false");
                }
            });

            // Prevent clicks inside popover from closing it
            $filterPopover.on("click", function(e) {
                e.stopPropagation();
            });

            // Apply filters button handler - this is where filtering happens in vertical layout
            $(".apply-filters").on("click", function(e) {
                e.stopPropagation();
                // Save the current state as the last applied state
                lastAppliedFilterState = saveFormState();
                // Trigger filtering only when Apply is clicked
                $form.trigger("apply-filters");
                // Update filter button state
                $this.updateFilterButtonState($form, $filterBtn, isVerticalLayout, enableFavorites);
                $filterPopover.removeClass("open").attr("aria-hidden", "true");
                fixScoreContainerZIndex(false);
                $filterBtn.removeClass("active").attr("aria-expanded", "false");
                $filterPopover.attr("aria-modal", "false");
                $filterBtn.focus();
            });

            // Handle form reset in popover
            $form.on("reset", function(e) {
                setTimeout(function() {
                    // Clear the vertical keyword search input if it exists
                    if ($("#vertical-keyword-search").length) {
                        $("#vertical-keyword-search").val("");
                    }

                    // Check if this is a user-triggered reset (from Clear All Filters button)
                    const isUserTriggeredReset = e.originalEvent && e.originalEvent.isTrusted;

                    // Only trigger filtering if we're applying changes
                    if (!isVerticalLayout) {
                        $form.trigger("input");
                    } else {
                        // In vertical layout, only auto-apply on initial load (not user-triggered)
                        if (!isUserTriggeredReset) {
                            $form.trigger("apply-filters");
                        }
                    }

                    // Update filter button state after reset
                    if (isVerticalLayout) {
                        $this.updateFilterButtonState($form, $filterBtn, isVerticalLayout, enableFavorites);
                    }
                }, 0);
            });
        }

        // Modified form event handler - different behavior for vertical vs classic layout
        $form
            .on(isVerticalLayout ? "apply-filters" : "input reset", function(e) {
                setTimeout(function() {
                    //creates a javascript array of objects, ready to be encoded as a JSON string
                    let arr = $form.serializeArray();

                    // Remove the show-favorites-only item from the array if it exists
                    // because we'll handle favorites filtering separately
                    arr = arr.filter(item => item.name !== "show-favorites-only");

                    $this.renderSelectedFilterChiclets(selectedFilterContainer, $form, isVerticalLayout, enableFavorites);

                    let category = "";
                    let selectors = "";
                    let itemsPerPage = $(window).width() <= 768 ? itemsMobile : itemsDesktop;
                    let totalItems = $resetItems.length;
                    let pages = Math.ceil(totalItems / itemsPerPage);
                    let keywordStr = isVerticalLayout
                        ? $("#vertical-keyword-search").length && $("#vertical-keyword-search").val().length > 2
                            ? $("#vertical-keyword-search")
                                  .val()
                                  .toLowerCase()
                            : ""
                        : $("#keyword-search").length && $("#keyword-search").val().length > 2
                        ? $("#keyword-search")
                              .val()
                              .toLowerCase()
                        : "";
                    let $items = [];

                    // Filter by favorites if enabled and active
                    let showFavoritesOnly = false;
                    if (enableFavorites) {
                        showFavoritesOnly = isVerticalLayout ? $(".favorites-btn").hasClass("active") : $("#show-favorites-only").is(":checked");
                    }

                    // sets item variables
                    if (arr.length < 1 || selectors == "") {
                        $items = $resetItems;
                    }

                    //appends items to gallery-items ( this shows as empty in the final result?)
                    $items.appendTo(".gallery-items");
                    //clears out gallery
                    $gallery.html("");
                    //clears control (this is invisible on live site)
                    $(".carousel-indicators").html("");

                    // If favorites only mode is active, ignore all other filters
                    if (enableFavorites && showFavoritesOnly) {
                        const favorites = $this.loadFavorites();
                        $items = $resetItems.filter(function(index, item) {
                            const itemId = $(item).data("item-id");
                            if (!itemId) {
                                return false;
                            }
                            return favorites.includes(itemId);
                        });
                    } else {
                        // Apply regular filtering only when favorites is not active

                        // creates selector data tags based on form selection
                        for (var index = 0; index < arr.length; index++) {
                            if (selectors !== "") selectors;
                            selectors += `[data-tags*='${arr[index].name}:${arr[index].value}']`;

                            // if index is the last or the index ahead does not equal the name of the curren index (for doubling??)
                            if (index === arr.length - 1 || arr[index + 1].name !== arr[index].name) {
                                // filters items based on selections made
                                $items = $items.filter(selectors);
                                selectors = "";
                            }

                            category = arr[index].name;
                        }

                        // Filter by text search
                        $items = $items.filter(function(index, item) {
                            return item.innerText.toLowerCase().indexOf(keywordStr) > -1;
                        });
                    }
                    // Store total filtered items count in a data attribute for later use
                    $gallerySection.data("total-filtered-items", $items.length);

                    // update pagination when filtered
                    pages = Math.ceil($items.length / itemsPerPage);

                    //update page item count with pagination format
                    if ($items.length === 0) {
                        $(".item-count").text("0 Results");
                    } else {
                        const firstItem = 1;
                        const lastItem = Math.min(itemsPerPage, $items.length);
                        $(".item-count").text(firstItem + "-" + lastItem + " of " + $items.length + " Results");
                    }

                    //create pages of items
                    for (var i = 0; i < pages; i++) {
                        $items.slice(i * itemsPerPage, (i + 1) * itemsPerPage).wrapAll('<div class="item">');
                        $(".carousel-indicators").append(`<li data-target="#video-gallery" data-slide-to="${i}" role="tab" aria-label="Page ${i + 1}" aria-selected="false" tabindex="0"></li>`);
                    }

                    //activate first page
                    $(".gallery-items .item")
                        .appendTo(".carousel-inner")
                        .eq(0)
                        .addClass("active");
                    $(".carousel-indicators li:first-child")
                        .addClass("active")
                        .attr("aria-selected", "true");

                    //configure nav
                    if ($("#video-gallery .item").length > 0) {
                        $next.removeClass("invisible");
                        $prev.addClass("invisible");
                        $(".controls-wrap").removeClass("invisible");
                    } else {
                        $(".controls-wrap").addClass("invisible");
                    }

                    totalItems < itemsPerPage || $items.length <= itemsPerPage ? $(".controls-wrap").addClass("invisible") : ($next.removeClass("invisible"), $(".controls-wrap").removeClass("invisible"));

                    // Update filter button state if in vertical layout
                    if (isVerticalLayout) {
                        $this.updateFilterButtonState($form, $filterBtn, isVerticalLayout, enableFavorites);
                    }
                }, 0);
            })
            .trigger("reset");

        // Save initial state after form is initialized for vertical layout
        if (isVerticalLayout) {
            setTimeout(() => {
                lastAppliedFilterState = saveFormState();
            }, 100);
        }

        $controls.on("click", function(e) {
            function setControls(index, length) {
                if (index === 0 && length === 1) {
                    $(".controls-wrap").addClass("invisible");
                }
                if (index === 0) {
                    $prev.addClass("invisible").attr("aria-disabled", "true");
                } else {
                    $prev.removeClass("invisible").attr("aria-disabled", "false");
                }
                if (index === length - 1) {
                    $next.addClass("invisible").attr("aria-disabled", "true");
                } else {
                    $next.removeClass("invisible").attr("aria-disabled", "false");
                }
            }
            setTimeout(function() {
                let activeItem = Array.from(document.querySelectorAll("#video-gallery .item.active")),
                    galleryItems = Array.from(document.querySelectorAll("#video-gallery .item")),
                    indicators = $(".carousel-indicators li"),
                    index = galleryItems.indexOf(activeItem[0]);
                setControls(index, galleryItems.length);

                // Update ARIA states for indicators
                indicators
                    .removeClass("active")
                    .attr("aria-selected", "false")
                    .filter(":nth-child(" + (index + 1) + ")")
                    .addClass("active")
                    .attr("aria-selected", "true");
            }, 0);
        });
        $carousel.on("slide.bs.carousel", function(e) {
            var activeList = $(e.relatedTarget),
                index = activeList.index(),
                length = $("#video-gallery .item").length;
            index === 0 ? $prev.addClass("hidden") : $prev.removeClass("hidden"); //first question
            index === length - 1 ? $next.addClass("hidden") : $next.removeClass("hidden");

            setTimeout(function() {
                $(".carousel-indicators li")
                    .removeClass("active")
                    .filter(":nth-child(" + (index + 1) + ")")
                    .addClass("active");
            }, 1);

            // Scroll to top of filter content when pagination changes
            scrollToElement(".gallery-section");
        });

        $("#webinar-video-modal").on("focus", event => {
            event.preventDefault();
        });

        $("#webinar-video-modal")
            .on("show.bs.modal", function(e) {
                let vimeoLink = $(e.relatedTarget).data("vimeo-link");
                let modalBody = document.querySelector(".video-modal-body");
                let vimeoWrapper = modalBody.querySelector(".vimeo-player-wrapper");
                let brightcoveWrapper = modalBody.querySelector(".brightcove-player-wrapper");

                //grab video ID
                let videoId = $(e.relatedTarget).data("video-id");
                //grab title
                let title = $(e.relatedTarget)
                    .find(".video-title")
                    .html();
                //grab description
                let description = $(e.relatedTarget)
                    .find(".video-description")
                    .html();
                if (vimeoLink) {
                    let image = modalBody.querySelector(".vimeo-poster-image");
                    let posterSrc = e.relatedTarget.dataset.posterImage;
                    image.style.backgroundImage = `url(${posterSrc})`;
                    vimeoWrapper.style.display = "block";
                    brightcoveWrapper.style.display = "none";

                    // Dispatch custom event for Alpine components
                    window.dispatchEvent(
                        new CustomEvent("vimeo-modal-show", {
                            detail: {
                                vimeoLink,
                                videoId,
                                title,
                                description,
                                posterSrc
                            }
                        })
                    );
                }
                $(this)
                    .find(".modal-title")
                    .html(title);
                $(this)
                    .find(".modal-description")
                    .html(description);

                let hasTranscript = false;
                let transcriptHtml = $(".video_transcript.hidden[data-video-id='" + videoId + "']").html();

                if (transcriptHtml !== undefined && transcriptHtml.length > 0) {
                    hasTranscript = true;
                    let pane = $("#webinar-video-modal #video-transcript .pane-wrapper");

                    pane.empty();
                    pane.append(transcriptHtml);
                } else {
                    hasTranscript = false;
                    $("#webinar-video-modal #video-transcript .pane-wrapper").empty();
                }

                $(".modal-footer").fadeIn(1200);

                // Store reference to element that triggered the modal for focus management
                // Only set from e.relatedTarget if we haven't already set it manually
                if (!modalTriggerElement && e.relatedTarget) {
                    modalTriggerElement = e.relatedTarget;
                } else if (modalTriggerElement) {
                    // Element already set manually
                }
            })
            .on("hide.bs.modal", function(e) {
                let vimeoLink = e.currentTarget.querySelector("iframe");
                if (vimeoLink) {
                    return;
                } else {
                    let player = document.querySelector("video");
                    if (player) {
                        let myPlayer = videojs(player);
                        myPlayer.dispose();
                    }
                }
                $(".modal-footer").hide();

                // Restore focus to the triggering element with a small delay
                if (modalTriggerElement) {
                    setTimeout(() => {
                        // Check if the element still exists and is focusable
                        if (modalTriggerElement && $(modalTriggerElement).is(":visible")) {
                            $(modalTriggerElement).focus();
                        } else {
                            // eslint-disable-next-line no-console
                            console.warn("Modal trigger element not available for focus");
                        }
                        // Clear the reference
                        modalTriggerElement = null;
                    }, 100);
                }
            });

        $(".pane-wrapper").on("scroll", function(ev) {
            this.scrollTop + this.offsetHeight + 1 >= this.scrollHeight
                ? $(this)
                      .parent()
                      .addClass("scroll-to-bottom")
                : $(this)
                      .parent()
                      .removeClass("scroll-to-bottom");
        });
        function clearActiveState() {
            $(".chapters__tab, .transcript__tab, .tab-pane").removeClass("active");
        }
        $(".gallery-item").on("click", function() {
            clearActiveState();
        });

        // Update item count on pagination changes
        $carousel.on("slid.bs.carousel", function() {
            const activeIndex = $(".carousel-inner .item.active").index();
            const itemsPerPage = $(window).width() <= 768 ? itemsMobile : itemsDesktop;
            const totalItems = $gallerySection.data("total-filtered-items");

            if (totalItems > 0) {
                const firstItem = activeIndex * itemsPerPage + 1;
                const lastItem = Math.min((activeIndex + 1) * itemsPerPage, totalItems);
                $(".item-count").text(firstItem + "-" + lastItem + " of " + totalItems + " Results");
            }
        });

        // Add keyboard accessibility for video gallery items
        $(document).on("keydown", ".video-thumb[role='button'], .video-link[role='button']", function(e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();

                // For video-link elements, explicitly trigger the modal
                if ($(this).hasClass("video-link")) {
                    const modalTarget = $(this).data("target");
                    if (modalTarget) {
                        // Store the triggering element for focus management
                        modalTriggerElement = this;
                        $(modalTarget).modal("show");

                        // Manually trigger the Alpine.js click event if it exists
                        const alpineClick = $(this).attr("@click");
                        if (alpineClick && window.Alpine) {
                            // Try to evaluate the Alpine expression
                            try {
                                eval(alpineClick);
                            } catch (e) {
                                // eslint-disable-next-line no-console
                                console.warn("Could not evaluate Alpine click expression:", e);
                            }
                        }
                    }
                } else {
                    // For other elements, use regular click
                    $(this).click();
                }
            }
        });

        // Add keyboard accessibility for favorite toggle buttons
        $(document).on("keydown", ".favorite-toggle", function(e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                $(this).click();
            }
        });

        // Add click handler for video-link elements to ensure modal triggers properly
        $(document).on("click", ".video-link[role='button']", function(e) {
            e.preventDefault();
            const modalTarget = $(this).data("target");
            if (modalTarget) {
                // Store the triggering element for focus management
                modalTriggerElement = this;
                $(modalTarget).modal("show");

                // Manually trigger the Alpine.js click event if it exists
                const alpineClick = $(this).attr("@click");
                if (alpineClick && window.Alpine) {
                    // Try to evaluate the Alpine expression
                    try {
                        eval(alpineClick);
                    } catch (e) {
                        // eslint-disable-next-line no-console
                        console.warn("Could not evaluate Alpine click expression:", e);
                    }
                }
            }
        });

        // Add keyboard navigation for pagination controls
        $(document).on("keydown", ".controls-wrap .prev, .controls-wrap .next", function(e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                $(this).click();

                // Move focus to filters button if in vertical layout
                if (isVerticalLayout) {
                    setTimeout(() => {
                        $("#show-filters-btn").focus();
                    }, 100);
                }
            }
        });

        // Add keyboard navigation for carousel indicators
        $(document).on("keydown", ".carousel-indicators li", function(e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                $(this).click();

                // Move focus to filters button if in vertical layout
                if (isVerticalLayout) {
                    setTimeout(() => {
                        $("#show-filters-btn").focus();
                    }, 100);
                }
            } else if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
                e.preventDefault();
                const $indicators = $(".carousel-indicators li");
                const currentIndex = $indicators.index(this);
                let newIndex;

                if (e.key === "ArrowLeft") {
                    newIndex = currentIndex > 0 ? currentIndex - 1 : $indicators.length - 1;
                } else {
                    newIndex = currentIndex < $indicators.length - 1 ? currentIndex + 1 : 0;
                }

                $indicators
                    .eq(newIndex)
                    .focus()
                    .click();
            }
        });

        // Initialize filter button state if in vertical layout
        if (isVerticalLayout) {
            // Wait for form to be initialized before checking state
            setTimeout(() => {
                if ($filterBtn && $filterBtn.length) {
                    this.updateFilterButtonState($form, $filterBtn, isVerticalLayout, enableFavorites);
                }
            }, 100);
        }
    }
}

export default FilterGalleryForm;
